import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './LegalDisclaimerPage.scss';

export const LegalDisclaimerPage: FC = (): ReactElement => (
    <Page className="legal-disclaimer-page">
        <ConnectedPageHelmet appRoute={AppRoute.legalDisclaimer} />
        <ConnectedBlockRenderer appRoute={AppRoute.legalDisclaimer} />
    </Page>
);
